import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { Person } from "../../types/person";
import EntityTable from "../EntityTable";
import {
  extractPersonEditLink,
  extractPersonViewLink,
} from "../entitiesReferences/InternalEntityLink";
import { renderRowViewAndUpdateActions } from "../../common/TableUtils";
import {
  personTableColumns,
  personFilterSpec,
} from "../../common/entities/PersonColumns";
import usePersonQuery from "../../hooks/query/usePersonQuery";
import { MRT_ColumnDef } from "material-react-table";
import useServerFilters from "../../hooks/useServerFilters";

interface PersonTableProps {
  columns?: MRT_ColumnDef<Person, any>[];
  filters?: Partial<Person>;
  enableRowActions?: boolean;
}

const PersonTable: React.FC<PersonTableProps> = ({
  columns = personTableColumns,
  filters = {},
  enableRowActions = true,
}) => {
  const navigate = useNavigate();

  const {
    serverFilters,
    entityTableFilterProps,
    pagination,
    setPagination,
  } = useServerFilters(filters, personFilterSpec);

  const { useFetchAll } = usePersonQuery();
  const { data, isLoading, errorMessage } = useFetchAll({
    filters: serverFilters,
    externalPagination: pagination,
    externalSetPagination: setPagination,
  });

  const renderRowActions = useMemo(
    () =>
      renderRowViewAndUpdateActions(
        (person: Person) => navigate(extractPersonViewLink(person)),
        (person: Person) => navigate(extractPersonEditLink(person))
      ),
    [navigate]
  );

  return (
    <EntityTable
      loading={isLoading}
      error={errorMessage}
      columns={columns}
      renderRowActions={renderRowActions}
      enableRowActions={enableRowActions}
      data={data?.data || []}
      pagination={pagination}
      manualPagination={true}
      onPaginationChange={setPagination}
      totalRowCount={data?.total || 0}
      manualFiltering
      {...entityTableFilterProps}
    />
  );
};

export default PersonTable;
